import { JSONEditor } from 'vanilla-jsoneditor';
import 'vanilla-jsoneditor/themes/jse-theme-dark.css';

function initJsonArrayEditors() {
    document.querySelectorAll('.json-array-editor-wrapper').forEach(function(wrapper) {
        if (wrapper.classList.contains('json-array-initialized')) return;
        wrapper.classList.add('json-array-initialized');

        const textarea = wrapper.querySelector('.json-array-textarea');
        const container = wrapper.querySelector('.json-array-editor-mount');

        let content = { json: [] };
        try {
            const parsed = JSON.parse(textarea.value);
            content = { json: parsed };
        } catch (e) {
            content = { json: [] };
        }

        new JSONEditor({
            target: container,
            props: {
                content,
                onChange: function(updatedContent) {
                    try {
                        const value = updatedContent.json !== undefined
                            ? updatedContent.json
                            : JSON.parse(updatedContent.text);
                        textarea.value = JSON.stringify(value);
                    } catch (e) {
                        // invalid JSON, don't sync
                    }
                },
            },
        });
    });
}

document.addEventListener('DOMContentLoaded', initJsonArrayEditors);
